import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
	categoryItem: {
		paddingLeft: theme.spacing(2),
		/**
		 * TO-DO: if padding is higher than 0, the popper opens with a gap, making hover lose integrity
		 */
		paddingRight: 0,
		"&:hover": {
			"& > div > svg": {
				color: colors.purple[500]
			},
			"& .MuiTypography-root": {
				color: colors.purple[500]
			}
		},
		transition: "color 0.4s ease, background-color 0.4s ease",
		"& > div > svg": {
			transition: "color 0.4s ease"
		},
		"& .MuiTypography-root": {
			transition: "color 0.4s ease"
		},
		"&:not(.sidebarOpen)": {
			paddingLeft: 0,
			paddingRight: 0,
			justifyContent: "center",
			"& .MuiListItemText-root": {
				display: "none"
			},
			"& .MuiListItemIcon-root": {
				minWidth: "auto",
				"& svg": {
					width: "20px",
					height: "20px"
				}
			}
		}
	},
	listItemActive: {
		position: "relative",
		"& > div > svg": {
			color: colors.purple[500]
		},
		"& .MuiTypography-root": {
			color: colors.purple[500]
		},
		"&:before": {
			position: "absolute",
			content: "close-quote",
			width: "4px",
			height: "100%",
			left: 0,
			top: 0,
			...ColorUtil.getBackgroundAndContrastColor(colors.getPrimaryColor())
		}
	},
	listItemText: {
		fontSize: "15px",
		fontWeight: 500,
		color: colors.gray[700]
	},

	listItemTextMuted: {
		fontSize: "15px",
		fontWeight: 500,
		color: colors.gray[500]
	},

	popperPaper: {
		maxHeight: "calc(100vh - 100px)",
		overflowY: "auto",
		width: 290,
		background: colors.gray[50]
	},

	link: {
		textDecoration: "none",
		color: "inherit",
		fontSize: "13px"
	},

	listItemIcon: {
		minWidth: "40px"
	},

	icon: {
		color: colors.gray[700]
	},

	disabledItem: {
		opacity: 0.5,
		"& .Mui-disabled": {
			opacity: "1 !important"
		}
	},

	disabledInfoIcon: {
		display: "flex",
		alignItems: "center",
		marginRight: "16px"
	}
}))

export default useStyles
